import ModelBase, {IModelBase} from '@/models/ModelBase'
import { KeyPair } from '@/types/KeyPair'

export interface IMessageTemplate extends IModelBase {
  title: string
  content: string
}

export default class MessageTemplate extends ModelBase {
  title = ''
  content = ''

  constructor(defaults?: IMessageTemplate) {
    super(defaults)
    if (defaults) {
      this.title = defaults.title
      this.content = defaults.content
    }
  }

  toParams(): KeyPair {
    return {
      title: this.title,
      content: this.content,
    }
  }
}